import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'
import { WordPressBrand, WixBrand, ShopifyBrand } from 'blaze-ui/icons/35'
import { GoHighLevel } from 'blaze-ui/icons/20/GoHighLevel'
import { ZapierLogo } from 'almanac-ui/icons/24'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

interface BlogProps extends IconProps {
  blogPlatform?: ExternalIntegrationEnum | null

  // @deprecated - use blogPlatform instead
  useGoHighLevelBranding?: boolean
  // @deprecated - use blogPlatform instead
  useWordPressBranding?: boolean
}

export const Blog = forwardRef<SVGSVGElement, BlogProps>(
  (
    {
      color = 'currentColor',
      size = 24,
      blogPlatform,
      useGoHighLevelBranding = false,
      useWordPressBranding = false,
      ...rest
    },
    forwardedRef,
  ) => {
    const resolvedUseGoHighLevelBranding = blogPlatform
      ? blogPlatform === ExternalIntegrationEnum.GoHighLevel
      : useGoHighLevelBranding

    const resolvedUseWordPressBranding = blogPlatform
      ? blogPlatform === ExternalIntegrationEnum.WordPress
      : useWordPressBranding

    const resolvedUseWixBranding = blogPlatform === ExternalIntegrationEnum.Wix
    const resolvedUseShopifyBranding = blogPlatform === ExternalIntegrationEnum.Shopify
    const resolvedUseZapierBranding = blogPlatform === ExternalIntegrationEnum.Zapier

    if (resolvedUseGoHighLevelBranding) {
      return <GoHighLevel color={color} size={size} ref={forwardedRef} {...rest} />
    }

    if (resolvedUseWordPressBranding) {
      return <WordPressBrand color={color} size={size} ref={forwardedRef} {...rest} />
    }

    if (resolvedUseWixBranding) {
      return <WixBrand color={color} size={size} ref={forwardedRef} {...rest} />
    }

    if (resolvedUseShopifyBranding) {
      return <ShopifyBrand color={color} size={size} ref={forwardedRef} {...rest} />
    }

    if (resolvedUseZapierBranding) {
      return <ZapierLogo color={color} size={size} ref={forwardedRef} {...rest} />
    }

    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 24 24"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g filter="url(#filter0_d_3841_8708)">
          <path
            d="M2.30872 4C2.30872 2.89543 3.20415 2 4.30872 2H20.3087C21.4133 2 22.3087 2.89543 22.3087 4V20C22.3087 21.1046 21.4133 22 20.3087 22H4.30872C3.20415 22 2.30872 21.1046 2.30872 20V4Z"
            fill="white"
          />
        </g>
        <path
          d="M5.49622 14.8682C5.49622 14.5921 5.72007 14.3682 5.99622 14.3682H18.6212C18.8974 14.3682 19.1212 14.5921 19.1212 14.8682C19.1212 15.1443 18.8974 15.3682 18.6212 15.3682H5.99622C5.72007 15.3682 5.49622 15.1443 5.49622 14.8682Z"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M5.49622 17.168C5.49622 16.8919 5.72007 16.668 5.99622 16.668H18.6212C18.8974 16.668 19.1212 16.8919 19.1212 17.168C19.1212 17.4442 18.8974 17.668 18.6212 17.668H5.99622C5.72007 17.668 5.49622 17.4442 5.49622 17.168Z"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M5.49622 19.4683C5.49622 19.1922 5.72007 18.9683 5.99622 18.9683H12.3237C12.5999 18.9683 12.8237 19.1922 12.8237 19.4683C12.8237 19.7444 12.5999 19.9683 12.3237 19.9683H5.99622C5.72007 19.9683 5.49622 19.7444 5.49622 19.4683Z"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M2.30872 4C2.30872 2.89543 3.20415 2 4.30872 2H20.3087C21.4133 2 22.3087 2.89543 22.3087 4V12.4297H2.30872V4Z"
          fill="url(#paint0_linear_3841_8708)"
        />
        <g filter="url(#filter1_d_3841_8708)">
          <path
            d="M5.49622 6.2908C5.49622 5.87728 5.83144 5.54206 6.24496 5.54206H18.3725C18.786 5.54206 19.1212 5.87728 19.1212 6.2908C19.1212 6.70433 18.786 7.03955 18.3725 7.03955H6.24496C5.83144 7.03955 5.49622 6.70433 5.49622 6.2908Z"
            fill="white"
            fillOpacity="0.78"
            shapeRendering="crispEdges"
          />
        </g>
        <g filter="url(#filter2_d_3841_8708)">
          <path
            d="M5.49622 9.11447C5.49622 8.70095 5.83144 8.36572 6.24496 8.36572H15.7482C16.1617 8.36572 16.4969 8.70095 16.4969 9.11447C16.4969 9.52799 16.1617 9.86322 15.7482 9.86322H6.24496C5.83144 9.86322 5.49622 9.52799 5.49622 9.11447Z"
            fill="white"
            fillOpacity="0.78"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3841_8708"
            x="0.308716"
            y="1"
            width="24"
            height="24"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3841_8708" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3841_8708" result="shape" />
          </filter>
          <filter
            id="filter1_d_3841_8708"
            x="4.49622"
            y="5.54199"
            width="15.625"
            height="3.49756"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3841_8708" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3841_8708" result="shape" />
          </filter>
          <filter
            id="filter2_d_3841_8708"
            x="4.49622"
            y="8.36572"
            width="13.0007"
            height="3.49756"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3841_8708" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3841_8708" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_3841_8708"
            x1="12.3087"
            y1="2"
            x2="12.3087"
            y2="12.4297"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBF19" />
            <stop offset="1" stopColor="#E27A00" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default Blog
